'use client';

import type { ProductFilterSchema } from '@coas/validators/payload';
import { useSearchParams } from 'next/navigation';
import type { UseFormReturn } from 'react-hook-form';
import { api } from 'trpc/react';
import type { RouterOutputs } from 'trpc/shared';
import IconChecked from '~/shared/assets/icons/checked.svg';
import { Spinner } from '~/shared/ui/spinner';

type FilterColorProps = {
    category: RouterOutputs['category']['getBySlug'] | null;
    list?: RouterOutputs['list']['getBySlug'] | null;
    form: UseFormReturn<ProductFilterSchema>;
};

export default ({ category, list, form }: FilterColorProps) => {
    const searchParams = useSearchParams();

    const { register, watch } = form;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { colors: _colors, ...filter } = watch();

    const {
        data: colors,
        isLoading,
        isSuccess,
    } = api.color.getAll.useQuery({
        category: category?.item.id ?? null,
        list: list?.item.id ?? null,
        search: searchParams.get('search') ?? '',
        filter,
    });

    return (
        <>
            {isLoading && <Spinner className={'absolute inset-0 m-auto h-8 w-8'} />}
            <div className={'flex w-full flex-col'}>
                {isSuccess &&
                    colors.map(color => {
                        return (
                            <label
                                key={color.id}
                                htmlFor={color.id}
                                className={'flex w-full items-center gap-x-4 py-2.5'}
                            >
                                <input
                                    id={color.id}
                                    type={'checkbox'}
                                    value={color.id}
                                    className={'peer -z-50 absolute opacity-0'}
                                    {...register('colors')}
                                />
                                <div
                                    className={'h-8 w-8 rounded-full border-1.5 border-neutral-200'}
                                    style={{ backgroundColor: color.value }}
                                />
                                <span className={'flex-1 space-x-3 text-start'}>
                                    <span className={'text-18 text-neutral-950'}>{color.name}</span>
                                    <span className={'font-300 text-16 text-neutral-500'}>
                                        ({color._count.productColors})
                                    </span>
                                </span>
                                <IconChecked
                                    className={'mb-1 h-5 w-5 stroke-transparent peer-checked:stroke-neutral-950'}
                                />
                            </label>
                        );
                    })}
            </div>
        </>
    );
};
